import React, { FC } from 'react';
import { Container } from '@design-system/container';
import { ExtendableImage } from '@design-system/extendable-image';
import { HeadingBlock } from '@design-system/heading-block';
import { Link } from '@design-system/link';
import { Section } from '@design-system/section';
import { columnBannerSchema } from '@root/components/ColumnBanner/ColumnBanner.schema';
import useJoiValidation from '@root/hooks/useJoiValidation';
import { gatsbyImageMapper } from '@theme-husky/mappers/image';

import { IColumnBannerProps } from './models';

import './ColumnBanner.scss';

const ColumnBanner: FC<IColumnBannerProps> = ({
  backgroundImage,
  backgroundImageAlt,
  headlineLeft,
  headlineRight,
  descriptionLeft,
  descriptionRight,
  ctaLeftUrl,
  ctaLeftLabel,
  ctaRightUrl,
  ctaRightLabel,
}) => {
  const {
    data,
  }: {
    data: IColumnBannerProps;
  } = useJoiValidation(columnBannerSchema, 'ColumnBanner', {
    backgroundImage,
    backgroundImageAlt,
    headlineLeft,
    headlineRight,
    descriptionLeft,
    descriptionRight,
    ctaLeftUrl,
    ctaLeftLabel,
    ctaRightUrl,
    ctaRightLabel,
  });

  return (
    <Section className="column-banner" element="div" mode="inverse">
      <Container maxWidth="max-grid" className="column-banner__container">
        <div className="column-banner__text">
          <HeadingBlock
            className="column-banner__heading"
            headline={data.headlineLeft}
            headlineTag="h2"
            headlineSize="xxl"
            description={data.descriptionLeft}
            descriptionSize="l"
          />
          <Link
            className="column-banner__cta"
            size="large"
            variant="primary"
            iconSuffix={{ props: { icon: 'arrowRight' } }}
            href={data.ctaLeftUrl}
          >
            {data.ctaLeftLabel}
          </Link>
        </div>
        <div className="column-banner__text">
          <HeadingBlock
            className="column-banner__heading"
            headline={data.headlineRight}
            headlineTag="h2"
            headlineSize="xxl"
            description={data.descriptionRight}
            descriptionSize="l"
          />
          <Link
            className="column-banner__cta"
            size="large"
            variant="primary"
            iconSuffix={{ props: { icon: 'arrowRight' } }}
            href={data.ctaRightUrl}
          >
            {data.ctaRightLabel}
          </Link>
        </div>
        <div className="column-banner__image">
          <ExtendableImage
            element={gatsbyImageMapper({
              alt: data.backgroundImageAlt,
              image: data.backgroundImage,
              objectFit: 'cover',
            })}
          />
        </div>
      </Container>
    </Section>
  );
};
export default ColumnBanner;
